import { FC } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { Controller } from 'react-hook-form';

import MuiFormLabel from '@material-ui/core/FormLabel';

import TextField, { TextFieldProps } from '@quanterix-ui/core/TextField';

import { handleChangeWithLengthLimit } from 'src/utils/helpers/form';

import { useStyles as useCommonStyles } from '../styles';

import { STATE_MAX_LENGTH, STATE_PATTERN } from './constants';

interface Props extends TextFieldProps {
  name: string;
  label?: string;
}

const ControlledStateTextField: FC<Props> = ({
  id,
  name,
  label,
  required = true,
  ...restProps
}) => {
  const commonClasses = useCommonStyles();

  const { formatMessage } = useIntl();

  return (
    <>
      <MuiFormLabel
        htmlFor={id ?? name}
        required={required}
        className={commonClasses.label}
      >
        {label ?? <FormattedMessage id="app.form.label.state" />}
      </MuiFormLabel>
      <Controller
        name={name}
        rules={{
          required,
          pattern: {
            value: STATE_PATTERN,
            message: formatMessage({ id: 'app.form.error.invalid_entry' }),
          },
        }}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            fullWidth
            id={id ?? name}
            value={value}
            error={!!error}
            helperText={error?.message}
            placeholder={formatMessage({ id: 'app.form.placeholder.state' })}
            onChange={(event) =>
              onChange(
                handleChangeWithLengthLimit(event, value, STATE_MAX_LENGTH)
              )
            }
            {...restProps}
          />
        )}
      />
    </>
  );
};

export default ControlledStateTextField;
